"use-client";
import NoImage from "@/assets/images/no-image.webp";
import { RenderCategoriesForMobile } from "@/components/CategoriesList/CategoriesList";
import DynamicImage from "@/components/DynamicImages/DynamicImage";
import { Button } from "@/components/ui/button";
import { categoriesApiSlice } from "@/redux/apiSlices/categoriesApi";
import Link from "next/link";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";

const CategoryCard = () => {
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => categoriesApiSlice.endpoints.getCategories.select()(state)?.data
  );
  const categoriesData = data?.data || [];

  const generateHref = (category, mainSlug) => {
    const { isTagged, fieldIds, fieldValueIds } = category;
    if (isTagged) {
      // Filter out undefined or null values
      const validFieldIds = fieldIds?.filter(
        (id) => id !== undefined && id !== null
      );
      const validFieldValueIds = fieldValueIds?.filter(
        (id) => id !== undefined && id !== null
      );

      // Construct the URL query only if valid values exist
      const query = [
        validFieldIds?.length ? `fieldIds=${validFieldIds.join(",")}` : null,
        validFieldValueIds?.length
          ? `fieldValueIds=${validFieldValueIds.join(",")}`
          : null,
      ]
        .filter(Boolean) // Remove null or undefined parts of the query
        .join("&");

      return query ? `${mainSlug}?${query}` : mainSlug;
    } else {
      return mainSlug;
    }
  };

  const updateBreadcrumb = (breadcrumb) => {
    dispatch(
      AddNewBreadcrum(breadcrumb)
    );
  };

  return (
    <>
      <CategoryCardWrapper className="grid grid-cols-3 rounded-[18px] overflow-hidden 1105:grid-cols-2 sm:hidden">
        {categoriesData.length > 0 &&
          categoriesData.slice(0, 6).map((category, index) => {
            const { subCategoryCounts } = category;
            return subCategoryCounts !== 0 ? (
              <div
                key={index}
                className="inline-flex gap-[10px] justify-center  bg-white font-semibold min-h-[305px] py-[54px] px-5 md:justify-start"
              >
                <div className="max-w-[115px] w-full inline-flex items-center ">
                  <DynamicImage
                    alt={category.name}
                    src={category?.categoryPicture || NoImage.src}
                    width={103}
                    height={195}
                    className="mx-auto my-0"
                  />
                </div>
                <div className="grid grid-rows-auto1fr min-w-[196px] md:min-w-min">
                  <h3 className="text-xl leading-[25px] text-blue2 font-medium mb-3">
                    {category?.categoryName}
                  </h3>
                  <div className="flex flex-col justify-between items-start overflow-hidden">
                    <ul>
                      {category?.subcategories.length > 0 &&
                        category.subcategories.slice(0, 5).map(
                          (subcategory, index) =>
                            subcategory?.slug !==
                              "smart-appliances/browse-by-feature" && (
                              <li
                                key={index}
                                className="text-gray2 text-[13px] leading-[16.5px] my-1 flex font-medium"
                              >
                                <span className="mr-2 w-[17px] h-[17px] inline-flex justify-center items-center bg-light-gray lg:bg-mobileBG rounded-full">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="11"
                                    viewBox="0 0 11 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M5.97409 5.49974L3.98729 7.4865L4.55494 8.05414L7.10938 5.49974L4.55494 2.94531L3.98729 3.51296L5.97409 5.49974Z"
                                      fill="#5C5C5C"
                                    />
                                  </svg>
                                </span>
                                <Link
                                  href={`/${subcategory?.slug}`}
                                  onClick={() =>
                                    updateBreadcrumb([
                                      {
                                        name: category?.categoryName,
                                        url: `/${category?.slug}`,
                                      },
                                      {
                                        name: subcategory.subCategoryName,
                                        url: `/${subcategory?.slug}`,
                                      }
                                    ])
                                  }
                                >
                                  {subcategory.subCategoryName}
                                </Link>
                              </li>
                            )
                        )}
                    </ul>
                    <Link
                      href={`/${category?.slug}`}
                      onClick={() =>
                        updateBreadcrumb([{
                          name: category?.categoryName,
                          url: `/${category?.slug}`,
                        }])
                      }
                    >
                      <Button
                        className="h-[38px] mt-2 border-blue2 rounded-[8px] text-xs leading-[18px] font-semibold hover:text-white hover:bg-red2 hover:border-red1"
                        variant="outline"
                      >
                        View More
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              <PackageCard category={category} key={index} />
            );
          })}
      </CategoryCardWrapper>

      <div className="hidden sm:block ">
        {categoriesData.length > 0 &&
          categoriesData.map((category) => (
            <RenderCategoriesForMobile
              key={category.id}
              category={category}
              generateHref={generateHref}
              callBack={() => {}}
            />
          ))}
      </div>
    </>
  );
};

const PackageCard = ({ category }) => (
  <div
    key={category?.id}
    className=" bg-white font-semibold flex items-center justify-center flex-col"
  >
    <div className="max-w-[240px] ">
      <DynamicImage
        alt={category.name}
        src={category?.categoryPicture || NoImage.src}
        width={240}
        height={195}
        className="px-1 my-0"
      />
    </div>
    <div className="flex pt-2 items-center">
      <h3 className="text-[18px] leading-[25px] text-blue2 font-medium px-4 pr-[19px] ">
        {category?.categoryName}
      </h3>
      <Link href={`/${category?.slug}`}>
        <Button
          className="h-[38px] mt-2 border-blue2 rounded-[8px] text-xs leading-[18px] font-semibold hover:text-white hover:bg-red2 hover:border-red1"
          variant="outline"
        >
          View More
        </Button>
      </Link>
    </div>
  </div>
);

export default CategoryCard;

const CategoryCardWrapper = styled.div`
  > div {
    border-right: 1px solid #c2c2c2;
    border-top: 1px solid #c2c2c2;

    &:nth-child(3),
    &:nth-child(6),
    &:nth-child(9) {
      border-right: none;
    }
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      border-bottom: 0;
      border-top: 0;
    }
    &:nth-child(1),
    &:nth-child(4) {
    }
  }
  @media (max-width: 1105px) {
    > div {
      &:nth-child(3) {
        border-top: 1px solid #c2c2c2;
        border-right: 1px solid #c2c2c2;
      }
    }
  }
`;